module.exports = __webpack_public_path__ + "img/partner-new-icon1.30b65e49.svg";